import * as R from "ramda";
import { isDataRequest } from "./isDataRequest.mjs";
const getRangeHeader = (args) => {
  const rangeArg = R.prop("range", args);
  if (R.isNil(rangeArg) || R.not(isDataRequest(args)) || R.not(R.path(["datasource", "hasRangeHeader"]))) {
    return {};
  }
  const rangeValue = R.pipe(
    R.when(R.pipe(R.is(Array), R.not), R.of(Array)),
    R.when(
      R.pipe(R.length, R.equals(1)),
      R.pipe(R.prepend("0"), R.over(R.lensIndex(1), R.dec))
    ),
    R.converge((start, end) => `values=${start}-${end}`, [R.head, R.last])
  )(rangeArg);
  return { "x-range": rangeValue };
};
export {
  getRangeHeader
};
